<template>
  <edit ref="edit"></edit>
</template>

<script>
import Edit from './EditForm'
export default {
  props: ['id'],
  components: {
    Edit
  },
  mounted () {
    this.$refs.edit.edit(this.id)
  }
}
</script>
